// modules/PlanButton.js
import React from 'react';
import { Link } from 'react-router';
import Arrow from '../../images/arrow';
import renderHTML   from 'react-render-html';

class PlanButton extends React.Component {
	constructor(props) {
        super(props);
        this.state = {active: false};

		this.showBHoverEvent       = this.showBHoverEvent.bind(this);
		this.hideBHoverEvent       = this.hideBHoverEvent.bind(this);
		this.showBHoverAreas       = this.showBHoverAreas.bind(this);
		this.hideBHoverAreas       = this.hideBHoverAreas.bind(this);

        this.props.messenger.subscribe("a_"+this.props.id, this.showBHoverEvent);
        this.props.messenger.subscribe("c_"+this.props.id, this.hideBHoverEvent);
    }

	componentWillUnmount() {
		this.props.messenger.remove("a_"+this.props.id);
		this.props.messenger.remove("c_"+this.props.id);
	}

    showBHoverEvent() {
	    this.setState({active:true});
    }

    hideBHoverEvent() {
    	this.setState({active:false});
    }

    showBHoverAreas() {
		this.props.messenger.publish("a_"+this.props.id, {});
	}

	hideBHoverAreas() {
		this.props.messenger.publish("c_"+this.props.id, {});
	}

	render() {
		var divclasses = this.props.buttonclass;
		if (this.state.active) {
		    divclasses += " active";
	    }

	    if (this.props.active !== 0) {
			return (
				<Link to={this.props.buttonlink}>
					<div className={divclasses} id={this.props.id} onMouseEnter={this.showBHoverAreas}
						 onMouseLeave={this.hideBHoverAreas}>
						<div className="button-title">{renderHTML(this.props.children)}</div>
						<div className="button-action"><Arrow/></div>
						<div className="clear-div"></div>
					</div>
				</Link>
			);
		} else {
			divclasses += " nocursor";
			return (
				<div className={divclasses} id={this.props.id} onMouseEnter={this.showBHoverAreas}
					 onMouseLeave={this.hideBHoverAreas}>
					<div className="button-title">{renderHTML(this.props.children)}</div>
					<div className="button-action"></div>
					<div className="clear-div"></div>
				</div>
			);
		}
	}
}

export default PlanButton;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/PlanButton.js
 **/